import KeyFigureSeriesSpecification from "./KeyFigureSeriesSpecification.js";
import ModelFactory from "../../ModelFactory.js";
import PeriodRollingSeriesSpecification from "./PeriodRollingSeriesSpecification.js";
import RowSeriesSpecification from "./RowSeriesSpecification.js";

/**
 * Materialize instances of {@link AbstractSeriesSpecification}.
 */
class SeriesSpecificationFactory extends ModelFactory {
	allClasses() {
		return [
			KeyFigureSeriesSpecification,
			PeriodRollingSeriesSpecification,
			RowSeriesSpecification,
		];
	}

	_getTypeFromJson(json) {
		return json.key.type;
	}
}

const seriesSpecificationFactory = new SeriesSpecificationFactory();

export default seriesSpecificationFactory;
